export const MODIFY_CURRENCY = 'MODIFY_CURRENCY';

export function modifyCurrency(currency){
    return{
        type: MODIFY_CURRENCY,
        mainState: {
            currency: currency
        }
    }
}